
  import { Component } from 'vue-property-decorator'
  import ResourceView from '@/views/datatables/ResourceView.vue'
  import { mapActions, mapGetters } from 'vuex'
  import { GForm } from '@/components/forms/GForm'

@Component({
  components: {
    ResourceView,
  },
  methods: {
    ...mapActions('resources', ['setCursorSize']),
  },
  computed: {
    ...mapGetters('resources', ['getResource', 'all']),
  },
})
  export default class SystemUsers extends GForm {
  setCursorSize!: (size: number) => void
  }

